<template>
  <div>
    <template v-if="stock > 0">
      <base-button
        type="primary"
        class="w-full"
        size="large"
        @click="add_to_cart"
        v-if="!quantity"
      >
        افزودن به سبد خرید
      </base-button>

      <div
        class="flex items-center justify-between"
        v-else
      >
        <div class="flex items-center bg-white rounded-lg shadow">
          <base-button
            text
            size="large"
            :disabled="!can_add"
            @click="add_to_cart"
          >
            <nuxt-icon
              name="add"
              v-if="can_add"
            />

            <span
              class="w-4 text-xs text-gray-400 font-normal flex justify-center"
              v-else
            >
              حداکثر
            </span>
          </base-button>

          <div class="w-8 text-center">
            <div class="font-bold text-primary text-sm whitespace-nowrap">
              {{ quantity }}
              پک
            </div>

            <div class="text-xs text-gray-400 whitespace-nowrap mt-1">
              {{ quantity * quantityInPackage }}
              عدد
            </div>
          </div>

          <base-button
            text
            size="large"
            @click="minusFromCart(id)"
          >
            <nuxt-icon
              name="minus"
              v-if="quantity > 1"
            />

            <nuxt-icon
              name="trash"
              class="text-danger"
              v-else
            />
          </base-button>
        </div>

        <slot
          name="count-left"
          :quantity="quantity"
        ></slot>
      </div>
    </template>

    <div
      class="text-danger text-sm"
      v-else
    >
      ناموجود
    </div>
  </div>
</template>

<script setup>
import useCart from 'assets/js/composables/cart/useCart.js';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BaseButton from '~/components/base/BaseButton.vue';

const route = useRoute();

const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  stock: {
    type: Number,
    required: true,
  },
  quantityInPackage: {
    type: Number,
    required: true,
  },
});

const { cart, cart_total_quantity, minusFromCart, addToCart } = useCart();

const quantity = computed(() => {
  return cart.value.find(p => p.id === props.id)?.quantity ?? 0;
});

const can_add = computed(() => {
  return props.stock > quantity.value;
});

const add_to_cart = () => {
  if (!can_add.value) return;

  addToCart(props.id);
};
</script>

<style scoped></style>
